module.exports = __webpack_public_path__ + "static/media/2.1ff5e33a.jpg";